import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ThemeProvider";
import LandingPage from "@/pages/LandingPage";
import OnboardingFlow from "@/pages/OnboardingFlow";
import DiagnosticFlow from "@/pages/DiagnosticFlow";
import EmailCapture from "@/pages/EmailCapture";
import InsightPage from "@/pages/InsightPage";
import HiPPOEmailCapture from "@/pages/HiPPOEmailCapture";
import HiPPOInsightPage from "@/pages/HiPPOInsightPage";
import PartnerLogin from "@/pages/PartnerLogin";
import PartnerContext from "@/pages/PartnerContext";
import PartnerExpress from "@/pages/PartnerExpress";
import InvestorLogin from "@/pages/InvestorLogin";
import InvestorExpress from "@/pages/InvestorExpress";
import RetrieveInsight from "@/pages/RetrieveInsight";

// Feature flags
const INVESTOR_LENS_ENABLED = process.env.REACT_APP_INVESTOR_LENS_ENABLED === 'true';
const PARTNER_LENS_ENABLED = process.env.REACT_APP_PARTNER_LENS_ENABLED === 'true';

function App() {
  return (
    <ThemeProvider defaultTheme="dark">
      <div className="App min-h-screen bg-cipher-charcoal transition-colors">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/start/:sessionId" element={<OnboardingFlow />} />
            <Route path="/diagnostic/:sessionId" element={<DiagnosticFlow />} />
            <Route path="/email/:sessionId" element={<EmailCapture />} />
            <Route path="/insight/:sessionId" element={<InsightPage />} />
            <Route path="/hippo/email/:sessionId" element={<HiPPOEmailCapture />} />
            <Route path="/hippo/:submissionId" element={<HiPPOInsightPage />} />
            {/* Partner routes - feature flagged */}
            <Route path="/partner" element={PARTNER_LENS_ENABLED ? <PartnerLogin /> : <Navigate to="/" replace />} />
            <Route path="/partner/express/:sessionId" element={PARTNER_LENS_ENABLED ? <PartnerExpress /> : <Navigate to="/" replace />} />
            <Route path="/partner/context/:sessionId" element={PARTNER_LENS_ENABLED ? <PartnerContext /> : <Navigate to="/" replace />} />
            {/* Investor routes - feature flagged */}
            <Route path="/investor" element={INVESTOR_LENS_ENABLED ? <InvestorLogin /> : <Navigate to="/" replace />} />
            <Route path="/investor/express/:sessionId" element={INVESTOR_LENS_ENABLED ? <InvestorExpress /> : <Navigate to="/" replace />} />
            <Route path="/retrieve" element={<RetrieveInsight />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
